export default function utils() {
	return {
		resolveState({ errors, pending, valid }) {
			if (errors[0]) return 'error';
			if (pending) return 'validating';
			if (valid) return '';
			return '';
		},
		// async humanize(permalink, fields) {
		// 	const app = await self.$gestios.app(permalink).data();

		// 	if (app) {
		// 		const appFields = app.Fields;

		// 		const rfields = {};
		// 		Object.keys(fields).forEach((key) => {
		// 			const field = appFields[key];

		// 			if (field) {
		// 				switch (field.Type) {
		// 					case 'relation':
		// 					case 'user':
		// 						rfields[key] = parseInt(fields[key].key, 10);
		// 						break;

		// 					case 'select':
		// 					case 'number':
		// 						rfields[key] = parseInt(fields[key], 10);
		// 						break;

		// 					case 'double':
		// 						rfields[key] = parseFloat(fields[key]);
		// 						break;

		// 					default:
		// 						rfields[key] = fields[key];
		// 				}
		// 			} else {
		// 				rfields[key] = fields[key];
		// 			}
		// 		});

		// 		return rfields;
		// 	}

		// 	return fields;
		// }
	}
};
